import { TextareaField as UnstyledTextareaField, withClassName } from '@epages/react-components'

export default withClassName('ep-form-text-area')(UnstyledTextareaField)
